module.exports = __webpack_public_path__ + "static/media/location-pic3.34350d20.png";